import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as styles from './index.module.scss';
import { Row } from 'antd';

import ColItem from './components/colItem';
import LINKS from '../../../constants';
import useIsMobile from '@/hooks/useIsMobile';
const Index = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const isMobile = useIsMobile();
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry?.isIntersecting && !isPlaying) {
          try {
            videoElement?.play().then(() => {
              setIsPlaying(true);
            });
          } catch (error) {
            console.log('play video error', error);
          }
        } else if (entry?.isIntersecting && isPlaying) {
          try {
            videoElement?.pause();
            setIsPlaying(false);
          } catch (error) {
            console.log('pause video error', error);
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // 当至少有50%的视频可见时触发
    });

    if (videoElement) {
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  }, []);

  const items = [
    {
      label: 'Tournament Prizes',
      desc: 'Users can earn varying amounts of MTT Tokens by participating in various free tournaments hosted by the MTT Sports, competing against other players, and securing rankings. This is the primary method of obtaining MTT Tokens.',
      img: 'https://cdn-web.mtt.xyz/static/Frame%201410077773.png',
      coming: false,
      link: LINKS.OFFICIAL,
    },
    {
      label: 'Mining Rewards',
      desc: 'MTT Network is a decentralized blockchain based on the Tendermint PoS consensus mechanism. Users can participate in block validation by setting up MTTNetwork nodes or by delegating their MTT Tokens to nodes for validation. The global distribution of nodes enhances the decentralization and security of the MTT Network.',
      img: 'https://cdn-web.mtt.xyz/static/Frame%201410077245t532wrf.png',
      coming: true,
    },
    {
      label: 'Network Grants',
      desc: 'The MTT Network Grants program aims to drive ecosystem growth by funding developers and creators who build applications, tools, or integrations that enhance MTT’s blockchain. It supports Web3 gaming innovation and community building, fostering a sustainable community of developers, users, and investors dedicated to MTT’s gaming and tournament ecosystem.',
      img: 'https://cdn-web.mtt.xyz/static/1243r4.png',
      coming: true,
    },
  ];

  const videoLink = useMemo(() => {
    if (isMobile)
      return 'https://static-s3.mtt.xyz/app/mtt-cms/form-assets/rls/00cfe18b.mp4';
    return 'https://static-s3.mtt.xyz/app/mtt-cms/form-assets/rls/01cf7a88.mp4';
  }, [isMobile]);
  return (
    <div className={styles.network}>
      <div className={styles.title}>
        How to get <span>$MTT Tokens</span> on the Network?
      </div>
      {/* <AnimationButton className={styles.button}>Learn More</AnimationButton> */}

      {/* <StaticImage
        className={styles.coins}
        src="https://cdn-web.mtt.xyz/static/20240718-015729%201.png"
        alt="MTT Tokens are at the Heart of the MTT Network."
      /> */}

      <div className={styles.coins}>
        <video ref={videoRef} muted>
          <source src={videoLink}></source>
        </video>
      </div>

      <Row
        className={styles.content}
        justify={{
          xxl: 'space-between',
          xl: 'space-between',
          lg: 'space-between',
          md: 'space-between',
          sm: 'center',
          xs: 'center',
        }}
        gutter={[0, 16]}
      >
        {items.map(({ label, img, desc, coming, link }, idx) => {
          return (
            <ColItem
              key={label + idx}
              label={label}
              desc={desc}
              img={img}
              coming={coming}
              link={link}
            />
          );
        })}
      </Row>
    </div>
  );
};

export default Index;
